import { ActivatedRoute, Router } from '@angular/router';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { AppMemoryService } from '../../core/app-memory.service';
import { DatePipe } from '@angular/common';
import { GetService } from '../../core/get.service';
import { StorageService } from '../../core/storage.service';
import { Horse } from '../../core/classes/horse';
import { Note } from '../../core/classes/note';
import { NotificationsService } from 'angular2-notifications';
import { Treatment } from '../../core/classes/treatment';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { RouteTypes } from '../../core/types/route-types';
import { saRegionKsa } from 'app/models/Regions';

declare const ImageCompressor: any;

@Component({
  selector: 'app-all-treatments',
  templateUrl: './all-treatments.component.html',
  styleUrls: ['./all-treatments.component.less'],
})
export class AllTreatmentsComponent implements OnInit {
  @ViewChild('imageLoader') public imageLoader: any;
  @ViewChild('imageLoader2') public imageLoader2: any;
  @ViewChild('imageLoader22') public imageLoader22: any;

  @ViewChild('measuresSelector') public measuresSelector: any;

  @ViewChild('updateHorseForm') public updateHorseForm: any;

  @ViewChild('createHorseForm') public createHorseForm: any;

  @ViewChild('createTreatmentForm') public createTreatmentForm: any;

  @ViewChild('updateTreatmentForm') public updateTreatmentForm: any;

  @ViewChild('weightsSelector') public weightsSelector: any;

  @HostListener('document:scroll', ['$event'])
  onWindowScroll() {
    if (
      $(window).scrollTop() >=
      $(document).height() - $(window).height() - 100
    ) {
      this.addNewData();
    }
  }

  public maxImgCount = environment.maxImgCount;
  public maxImgSize = environment.maxImgSize;

  public drugs: any;

  public objectKeys = Object.keys;

  public horse: Horse;

  public newHorse = new Horse();

  public newTreatment = new Treatment();

  public treatments: Treatments;
  public treatmentsByDate = [] as any;
  public treatmentsByDateArchive = [] as any;

  public currentTreatment: Treatment;

  public _searchStream = new Subject<any>();

  public routeTypes = ['intra-venous', 'intra-muscular', 'oral', 'other'];

  public serverError = null;
  public isRequestInProgress = false;
  public isRequestInProgress2 = false;
  public isRequestInProgress3 = false;
  public isRequestInProgress4 = false;
  public isRequestInProgress5 = false;
  public isRequestSuccess = false;

  public isMicrochipChanged = false;
  public isImagesChanged = false;

  public datePicker = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    isActive: false as boolean,
  };

  public datePicker2 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ '',
    isActive: false as boolean,
  };

  public datePicker3 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ '',
    isActive: false as boolean,
  };

  public datePicker4 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ '',
    isActive: false as boolean,
  };

  public datePicker5 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input:
      /*this.datePipe.transform(new Date(), environment.dateFormat)*/ '',
    isActive: false as boolean,
  };

  public loadSuggestion: boolean;

  public farmSelectModel: Array<Object> = [
    {
      id: null as number,
      text: '' as string,
    },
  ];

  public measuresSelectorModel: any;
  public weightsSelectorModel: any;

  public farmSelectModelLoaded = false;

  public treatmentStatus = {
    request_id: null as number,
    status: '' as string,
    comment: '' as string,
    vetclinic_id: 1 as number, // TO DO
  };

  public pagination = {
    inProgress: false as boolean,
    nextPage: '' as string,
  };

  public objectToArray(obj: Object) {
    return Object.keys(obj).map((key) => obj[key]); // transorm Array-like Object to Array
  }

  public isUserLoaded = false;

  public reportDate = {
    from: '' as string,
    to: '' as string,
    switcher: false as boolean,
  };

  public translation = {};

  public maxLength;
  public treatmentTypes = [];
  public hasNoTreatment = false;

  public regionKSA = saRegionKsa;

  /**
   * True when the treatment being viewed (read-only modal) belongs to the
   * Saudi Arabia (KSA) region. Drives KSA-only display rules — hide the
   * disclaimer and relabel the Medical Form 1A type — without affecting any
   * other region. Region lives on treatment.horse.farm.region (a region-id string).
   */
  get isCurrentTreatmentKsa(): boolean {
    return !!(
      this.currentTreatment &&
      this.currentTreatment.horse &&
      this.currentTreatment.horse.farm &&
      this.currentTreatment.horse.farm.region === this.regionKSA
    );
  }

  /**
   * True when the treatment being edited belongs to the KSA region. Drives the
   * KSA-only stripping of the edit modal — hide the form selector and disclaimer.
   */
  get isNewTreatmentKsa(): boolean {
    return !!(
      this.newTreatment &&
      this.newTreatment.horse &&
      this.newTreatment.horse.farm &&
      this.newTreatment.horse.farm.region === this.regionKSA
    );
  }

  constructor(
    private notificationsService: NotificationsService,
    public appMemory: AppMemoryService,
    public getService: GetService,
    public activatedRoute: ActivatedRoute,
    public datePipe: DatePipe,
    public translateService: TranslateService,
    private storage: StorageService
  ) {
    this.appMemory.userSubject.subscribe((e) => {
      if (this.appMemory.user && e && !this.isUserLoaded) {
        this.getHorseByUserRole();
        this.isUserLoaded = true;
      }
    });
    this.getTranslation();
  }

  /** Resolve an asset path to a (signed, in s3 mode) URL and open it. */
  public openAsset(imagePath: string) {
    if (!imagePath) { return; }
    this.storage.getDownloadUrl(imagePath).then((url) => window.open(url, '_blank'));
  }

  public calcQuantityMaxLength() {
    return 5;
  }

  public calcMaxLength(value) {
    if (value.toString().split('.')[1]) {
      const tmp = value.toString().split('.')[0].length + 3;

      if (tmp < 5) {
        this.maxLength = 5;
      } else {
        this.maxLength = tmp;
      }
    } else {
      this.maxLength = 5;
    }
    // console.log('THIS.MAXLENGTH', this.maxLength);
  }

  filterDrugs() {
    if (environment.filterRegionForDrugs) {
      this.drugs = this.appMemory.static.drugs.filter(
        (drug: any) => drug.region === this.newHorse.farm.region
      );
    }
  }

  getHorseByUserRole() {
    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getHorsesTreatments('/instructor');
        break;

      case 2:
        this.getHorsesTreatments('/assistant');
        break;

      case 3:
        this.getHorsesTreatments('/vet');
        break;
    }
  }

  getHorsesTreatments(role: string) {
    this.isRequestInProgress = true;

    this.getService.getHorsesTreatments(role).then(
      (res: any) => {
        this.pagination.nextPage = res.archive.next_page_url;

        if (res.alive) {
          res.alive.sort((a, b) => {
            const d1 = new Date(a.updated_at);
            const d2 = new Date(b.updated_at);
            //(( ( a.request && b.request && b.request.status.toLowerCase() == a.request.status.toLowerCase() ) || (!b.request && !a.request) ) ?  : 0)
            //return (d2.getTime() > d1.getTime() ? 1 : -1);
            if (!a.request && !b.request) {
              return d2.getTime() > d1.getTime() ? 1 : -1;
            } else if (a.request && b.request) {
              if (
                b.request.status.toLowerCase() != a.request.status.toLowerCase()
              ) {
                let f;
                switch (b.request.status.toLowerCase()) {
                  case 'pending':
                    f = 1;
                    break;
                  case 'cancelled':
                    f = -1;
                    break;
                  case 'approved':
                    if (a.request.status.toLowerCase() === 'pending') {
                      f = -1;
                    } else {
                      f = 1;
                    }
                    break;
                }
                return f;
              } else {
                return d2.getTime() > d1.getTime() ? 1 : -1;
              }
            } else {
              let f;
              if (!b.request) {
                if (a.request.status.toLowerCase() == 'approved') {
                  f = d2.getTime() > d1.getTime() ? 1 : -1;
                } else if (a.request.status.toLowerCase() === 'pending') {
                  f = -1;
                } else {
                  f = 1;
                }
              } else {
                if (b.request.status.toLowerCase() == 'approved') {
                  f = d2.getTime() > d1.getTime() ? 1 : -1;
                } else if (b.request.status.toLowerCase() == 'pending') {
                  f = 1;
                } else {
                  f = -1;
                }
              }
              return f;
            }
          });
        }

        this.treatments = res;
        this.sortArrayByDate(this.treatments.alive, 'alive');
        this.sortArrayByDate(this.treatments.archive.data, 'archive');
        this.isRequestInProgress = false;
      },
      (err: any) => {
        console.log('ERR', err);
        this.isRequestInProgress = false;
      }
    );
  }

  ngOnInit(): void {
    this.appMemory.staticLoaded.subscribe((val) => {
      // tslint:disable-next-line:curly
      if (!val) return;

      this.treatmentTypes = this.appMemory.static.treatments;
    });
  }

  debug(e) {
    console.log(e);
  }

  searchDrugs(e) {
    this.drugs = [];
    this.drugs[0] = this.appMemory.static.drugs[0];
    if (this.appMemory.static.drugs) {
      this.appMemory.static.drugs.forEach((el, i) => {
        if (
          el.name.toLowerCase().indexOf(e.toLowerCase()) !== -1 &&
          el.name.toLowerCase().indexOf(this.drugs[0].name.toLowerCase()) === -1
        ) {
          this.drugs.push(el);
        }
      });
    }
  }

  sortArrayByDate(array: any, type: string) {
    this.isRequestInProgress2 = true;

    switch (type) {
      case 'alive':
        const statusessss = {};

        this.treatmentsByDate = [];

        let tmp = undefined;
        array.forEach((e, i) => {
          if (e.request) {
            statusessss[e.request.status] = 1;
          }

          e.date = e.start_date; // .slice(0, -9);
          if (!tmp) {
            e.data = [e];
            tmp = e;
            if (i == array.length - 1) {
              this.treatmentsByDate.push(tmp);
              tmp = undefined;
            }
          } else {
            if (e.date == tmp.date) {
              tmp.data.push(e);
              if (i == array.length - 1) {
                this.treatmentsByDate.push(tmp);
                tmp = undefined;
              }
            } else {
              this.treatmentsByDate.push(tmp);
              tmp = undefined;
              e.data = [e];
              tmp = e;
              if (i == array.length - 1) {
                this.treatmentsByDate.push(tmp);
                tmp = undefined;
              }
            }
          }
        });
        if (tmp) {
          this.treatmentsByDate.push(tmp);
          tmp = undefined;
        }
        break;

      case 'archive':
        this.treatmentsByDateArchive = [];

        let tmp2 = undefined;

        array.forEach((e, i) => {
          e.date = e.start_date; // .slice(0, -9);
          if (!tmp2) {
            e.data = [e];
            tmp2 = e;
            if (i == array.length - 1) {
              this.treatmentsByDateArchive.push(tmp2);
              tmp2 = undefined;
            }
          } else {
            if (e.date == tmp2.date) {
              tmp2.data.push(e);
              if (i == array.length - 1) {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
              }
            } else {
              this.treatmentsByDateArchive.push(tmp2);
              tmp2 = undefined;
              e.data = [e];
              tmp2 = e;
              if (i == array.length - 1) {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
              }
            }
          }
        });

        if (tmp2) {
          this.treatmentsByDateArchive.push(tmp2);
          tmp2 = undefined;
        }
        break;
    }

    this.isRequestInProgress2 = false;
  }

  addNewData() {
    if (
      this.pagination.nextPage === null ||
      this.pagination.inProgress ||
      this.pagination.nextPage === ''
    ) {
      return;
    }
    this.pagination.inProgress = true;

    this.getService.rawRequest(this.pagination.nextPage).then(
      (res: any) => {
        let tmp2 = undefined;
        let tmp3 =
          this.treatmentsByDateArchive[this.treatmentsByDateArchive.length - 1];
        const array = res.archive.data;
        array.forEach((e, i) => {
          e.date = e.updated_at; // .slice(0, -9);
          if (tmp3 && tmp3.date == e.date) {
            this.treatmentsByDateArchive[
              this.treatmentsByDateArchive.length - 1
            ].data.push(e);
          } else {
            tmp3 = undefined;
            if (!tmp2) {
              e.data = [e];
              tmp2 = e;
              if (i == array.length - 1) {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
              }
            } else {
              if (e.date == tmp2.date) {
                tmp2.data.push(e);
                if (i == array.length - 1) {
                  this.treatmentsByDateArchive.push(tmp2);
                  tmp2 = undefined;
                }
              } else {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
                e.data = [e];
                tmp2 = e;
                if (i == array.length - 1) {
                  this.treatmentsByDateArchive.push(tmp2);
                  tmp2 = undefined;
                }
              }
            }
          }
        });
        if (tmp2) {
          this.treatmentsByDateArchive.push(tmp2);
          tmp2 = undefined;
        }
        this.pagination.nextPage = res.archive.next_page_url;

        this.pagination.inProgress = false;
      },
      (err: any) => {
        this.pagination.inProgress = false;
      }
    );
  }

  clearUserInput(form?: any, close?: boolean) {
    this.clearImages();
    this.serverError = null;
    if (form) {
      form.resetForm();
    }
    this.newTreatment = new Treatment();
    this.measuresSelectorModel = [];
    this.weightsSelectorModel = [];
    this.treatmentStatus.comment = '';
    $('#note-title-box').removeClass('input--filled');
    $('#note-descr-box').removeClass('input--filled');
    $('#comment-box').removeClass('input--filled');
    $('#quantity-box').removeClass('input--filled');
    $('#reason-box').removeClass('input--filled');
    /*$('#detection_time-box').removeClass('input--filled');*/
    $('#duration-box').removeClass('input--filled');
    $('#microchip-number-box').removeClass('input--filled');

    this.reportDate = {
      to: '',
      from: '',
      switcher: false,
    };
  }

  hideModal(noclear?: boolean) {
    if (!noclear) {
      this.clearImages();
    }
    $('.modal.open').removeClass('open');
    $('body').removeClass('modal-open');
  }
  clearImages() {
    if (this.imageLoader22) {
      this.imageLoader22.deleteAll();
    }
    if (this.imageLoader2) {
      this.imageLoader2.deleteAll();
    }
  }

  setMeasure(e) {
    // if (this.newTreatment.quantity_measure == 'other') {
    //     this.newTreatment.quantity = '';
    // }
    this.newTreatment.quantity_measure = e.id;
  }

  setImage(file: File) {
    this.newHorse.microchip = file;
    this.isMicrochipChanged = true;
  }

  setImages(file: File[]) {
    const that = this;

    this.newTreatment.src = file;
    this.isImagesChanged = true;

    setTimeout(() => {
      for (let i = 0; i < file.length; i++) {
        if (!(<any>file[i]).compressed) {
          new ImageCompressor((<any>file[i]).file, {
            maxWidth: 1000,
            maxHeight: 668,
            success(result) {
              (<any>file[i]).file = result;
              (<any>file[i]).compressed = true;
            },
            error(e) {
              console.log(e.message);
              that.notificationsService.error(
                `${this.translation['uploadImage']}`,
                `${this.translation['errorOccurred']}`
              );
            },
          });
        }
      }

      const imgs = $('.with_description .image-container .image');
      imgs.addClass('image-block');

      imgs.each((i) => {
        if ($(imgs[i]).find('.remove_on_remove_img').length == 0) {
          const a = `<div class="box-control remove_on_remove_img">
              <input type="text"
                     class="form-control input__field"
                     name="image_description_${i}"
                     autocomplete="off">
              <label class="input__label">
                <span>${this.translation['description']}</span>
              </label>
            </div>`;
          $(a).appendTo(imgs[i]);
        }
      });
    }, 200);
  }

  formatDate(date) {
    if (date) {
      const arr = date.split('/');
      switch (environment.dateFormat) {
        case 'MM/dd/yyyy':
          return arr[0] + '/' + arr[1] + '/' + arr[2];
        case 'dd/MM/yyyy':
        default:
          return arr[1] + '/' + arr[0] + '/' + arr[2];
      }
    }
  }

  setStartDate(date) {
    this.datePicker5.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
    this.newTreatment.start_date = this.datePipe
      .transform(date, 'yyyy-MM-dd')
      .replace(/\s/g, 'T');
    this.datePicker5.currentDate = date;
  }

  setStartDateInput() {
    if (this.serverError) {
      this.serverError.start_date = null;
    }
    if (
      new Date(this.formatDate(this.datePicker5.currentDate_input)).getTime() >
        this.datePicker5.maxDate.getTime() ||
      new Date(this.formatDate(this.datePicker5.currentDate_input)).getTime() <
        this.datePicker5.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePicker5.currentDate_input)
      ).toDateString() === 'Invalid Date'
    ) {
      if (this.serverError) {
        this.serverError.start_date = 'CORE.invalidDate';
      } else {
        this.serverError = { start_date: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker5.currentDate = new Date(
      this.formatDate(this.datePicker5.currentDate_input)
    );
    this.newTreatment.start_date = this.datePipe.transform(
      this.formatDate(this.datePicker5.currentDate_input),
      'yyyy-MM-dd'
    );
    this.datePicker5.isActive = false;
  }

  setWithdrawal(date) {
    this.datePicker2.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
    this.newTreatment.withdrawal = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.datePicker2.currentDate = date;
  }

  setWithdrawalInput() {
    if (this.serverError) {
      this.serverError.withdrawal = null;
    }
    if (
      new Date(this.formatDate(this.datePicker2.currentDate_input)).getTime() >
        this.datePicker2.maxDate.getTime() ||
      new Date(this.formatDate(this.datePicker2.currentDate_input)).getTime() <
        this.datePicker2.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePicker2.currentDate_input)
      ).toDateString() === 'Invalid Date'
    ) {
      if (this.serverError) {
        this.serverError.withdrawal = 'CORE.invalidDate';
      } else {
        this.serverError = { withdrawal: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker2.currentDate = new Date(
      this.formatDate(this.datePicker2.currentDate_input)
    );
    this.newTreatment.withdrawal = this.datePipe.transform(
      this.formatDate(this.datePicker2.currentDate_input),
      'yyyy-MM-dd'
    );
    this.datePicker2.isActive = false;
  }

  public datePickerMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  };

  setFromDateInput() {
    if (this.serverError) {
      this.serverError.from = null;
    }
    if (
      new Date(this.formatDate(this.datePicker3.currentDate_input)).getTime() >
        this.datePicker3.maxDate.getTime() ||
      new Date(this.formatDate(this.datePicker3.currentDate_input)).getTime() <
        this.datePicker3.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePicker3.currentDate_input)
      ).toDateString() === 'Invalid Date'
    ) {
      if (this.serverError) {
        this.serverError.from = 'CORE.invalidDate';
      } else {
        this.serverError = { from: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker3.currentDate = new Date(
      this.formatDate(this.datePicker3.currentDate_input)
    );
    this.reportDate.from = this.datePipe.transform(
      this.formatDate(this.datePicker3.currentDate_input),
      'yyyy-MM-dd'
    );
    this.datePicker3.isActive = false;
  }

  setToDateInput() {
    if (this.serverError) {
      this.serverError.to = null;
    }
    if (
      new Date(this.formatDate(this.datePicker4.currentDate_input)).getTime() >
        this.datePicker4.maxDate.getTime() ||
      new Date(this.formatDate(this.datePicker4.currentDate_input)).getTime() <
        this.datePicker4.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePicker4.currentDate_input)
      ).toDateString() === 'Invalid Date'
    ) {
      if (this.serverError) {
        this.serverError.to = 'CORE.invalidDate';
      } else {
        this.serverError = { to: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker4.currentDate = new Date(
      this.formatDate(this.datePicker4.currentDate_input)
    );
    this.reportDate.to = this.datePipe.transform(
      this.formatDate(this.datePicker4.currentDate_input),
      'yyyy-MM-dd'
    );
    this.datePicker4.isActive = false;
  }

  setDate(date: Date, type: number) {
    switch (type) {
      case 1:
        {
          if (this.serverError) {
            this.serverError.from = null;
          }
          this.datePicker3.currentDate_input = this.datePipe.transform(
            date,
            environment.dateFormat
          );
          this.reportDate.from = this.datePipe.transform(date, 'yyyy-MM-dd');
          this.datePicker3.currentDate = date;
          this.datePicker4.minDate = date;
        }
        break;

      case 2:
        {
          if (this.serverError) {
            this.serverError.to = null;
          }
          this.datePicker4.currentDate_input = this.datePipe.transform(
            date,
            environment.dateFormat
          );
          this.reportDate.to = this.datePipe.transform(date, 'yyyy-MM-dd');
          this.datePicker4.currentDate = date;
          this.datePicker3.maxDate = date;
        }
        break;
    }
  }

  updateTreatment(role: string, form: any) {

    if (
      !this.hasNoTreatment &&
      (form.form.invalid ||
        !this.newTreatment.drug ||
        !this.newTreatment.start_date ||
        !this.newTreatment.withdrawal ||
        !this.newTreatment.quantity_measure ||
        !this.isTreatmentEditable(this.newTreatment))
    ) {
      return;
    }

    console.log('new treatment', this.newTreatment);
    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    formData.append('horse_id', this.newTreatment.horse_id);
    formData.append('type', this.newTreatment.type);

    if (this.newTreatment.drug && this.newTreatment.drug.id) {
      formData.append('drug_id', this.newTreatment.drug.id);
    }

    if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
      formData.append('drug_name', this.newTreatment.drug_name);
    }

    // if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
    //   formData.append("drug_name", this.newTreatment.drug_name);
    //   formData.append("drug_brand", this.newTreatment.drug_brand);
    // }

    formData.append('route', this.newTreatment.route);

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLowerCase() === RouteTypes.other
    ) {
      formData.append('other_route', this.newTreatment.other_route);
    }

    if (this.newTreatment.route !== RouteTypes.noTreatment) {
      formData.append('reason', this.newTreatment.reason);
      formData.append('start_date', this.newTreatment.start_date);
      formData.append('withdrawal', this.newTreatment.withdrawal);
      formData.append('quantity', this.newTreatment.quantity);
      formData.append('other_quantity', this.newTreatment.other_quantity);
      formData.append('quantity_measure', this.newTreatment.quantity_measure);
      /*formData.append("detection_time", this.newTreatment.detection_time);*/
      // formData.append('duration', this.newTreatment.duration);
    }

    if (this.newTreatment.prescriptions[0].images) {
      const del = [];
      this.newTreatment.prescriptions[0].images.forEach((el) => {
        let flag = true;
        this.newTreatment.srcs.forEach((el2) => {
          if (flag && el2.id === el.id) {
            flag = false;
          }
        });
        if (flag) {
          del.push(el.id);
        }
      });
      if (del.length > 0) {
        const requestObj = {};
        switch (role) {
          case '/vet':
            requestObj['url'] =
              '/treatment-request-vet/' + this.newTreatment.id;
            break;
          case '/assistant':
            requestObj['url'] = '/treatment-request/' + this.newTreatment.id;
            break;
          case '/instructor':
            requestObj['url'] = '/instructor/treatment/' + this.newTreatment.id;
            break;
        }
        requestObj['params'] = { 'images[]': del };
        this.getService.removeImages(requestObj).then(
          (res) => {
            this.getHorseByUserRole();
          },
          (err) => {
            console.log(err);
          }
        );
      }
    }

    let needsS3Upload = false;
    if (this.newTreatment.src && this.isImagesChanged) {
      const imgs = $('.with_description .image-container .image');
      this.newTreatment.src.forEach((e, i) => {
        formData.append(
          'images[' + i + '][description]',
          $(imgs[i]).find('input').val()
        );
      });
      needsS3Upload = this.storage.appendFilesToForm(
        formData, 'images', this.newTreatment.src, null, true);
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getService
          .updateTreatment(role, formData, this.newTreatment.id)
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then(
            (res: any) => {
              this.clearUserInput(this.updateTreatmentForm);
              this.hideModal();
              this.getHorseByUserRole();
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation['editTreat']}`,
                `${this.translation['treatment']} ${this.translation['edittedSuccess']}`
              );
            }
          )
          .catch((err: any) => {
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation['editTreat']}`,
                `${this.translation['errorOccurred']}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;

      case 2:
        this.getService
          .updateTreatmentA(role, formData, this.newTreatment.id)
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then(
            (res: any) => {
              this.clearUserInput(this.updateTreatmentForm);
              this.hideModal();
              this.getHorseByUserRole();
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation['editTreat']}`,
                `${this.translation['treatment']} ${this.translation['edittedSuccess']}`
              );
            }
          )
          .catch((err: any) => {
              console.log('ERR', err);
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation['editTreat']}`,
                `${this.translation['errorOccurred']}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;

      case 3:
        this.getService
          .updateTreatmentV(role, formData, this.newTreatment.id)
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then(
            (res: any) => {
              this.clearUserInput(this.updateTreatmentForm);
              this.hideModal();
              this.getHorseByUserRole();
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation['editTreat']}`,
                `${this.translation['treatment']} ${this.translation['edittedSuccess']}`
              );
            }
          )
          .catch((err: any) => {
              console.log('ERR', err);
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation['editTreat']}`,
                `${this.translation['errorOccurred']}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;
    }
  }

  proceessTreatment(treatment: Treatment, form?: any) {
    if (form && form.form.invalid) {
    }

    if (!this.treatmentStatus.comment) {
      this.treatmentStatus.comment = undefined;
    }

    switch (this.treatmentStatus.status) {
      case 'approved':
        this.treatmentStatus.comment = undefined;
        this.treatmentStatus.vetclinic_id = 1;
        break;

      case 'cancelled':
        this.treatmentStatus.vetclinic_id = undefined;
        break;
    }

    this.getService
      .proceessTreatment(this.treatmentStatus.request_id, this.treatmentStatus)
      .then(
        (res: any) => {
          if (form) {
            this.clearUserInput(form);
          }

          this.hideModal();
          this.getHorseByUserRole();
          this.notificationsService.success(
            `${this.translation['updateTreatmentStatus']}`,
            `${this.translation['treatment']} ${this.translation['updatedSuccess']}`
          );
        },
        (err: any) => {
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation['updateTreatmentStatus']}`,
            `${this.translation['errorOccurred']}`
          );
          this.serverError = this.objectToArray(JSON.parse(err._body));
        }
      );
  }

  cloneTreatment(treatment: Treatment) {
    this.newTreatment = Object.assign({}, treatment);
    this.hasNoTreatment = this.newTreatment.route === RouteTypes.noTreatment;
    if (
      this.newTreatment.prescriptions &&
      this.newTreatment.prescriptions[0].drugs[0]
    ) {
      this.newTreatment.drug = this.newTreatment.prescriptions[0].drugs[0];
    } else {
      this.newTreatment.drug = {
        created_at: null,
        id: 0,
        name: this.translation['otherDrug'],
        updated_at: null,
      };
    }
    this.datePicker5.currentDate_input = this.datePipe.transform(
      new Date(this.newTreatment.start_date),
      environment.dateFormat
    );
    this.datePicker5.maxDate = new Date(this.newTreatment.withdrawal);
    this.datePicker5.currentDate = new Date(this.newTreatment.start_date);

    this.datePicker2.currentDate_input = this.datePipe.transform(
      new Date(this.newTreatment.withdrawal),
      environment.dateFormat
    );
    this.datePicker2.currentDate = new Date(this.newTreatment.withdrawal);
    this.datePicker2.minDate = new Date(this.newTreatment.start_date);

    this.newTreatment.other_quantity =
      this.newTreatment.prescriptions[0].other_quantity;
    this.newTreatment.quantity = this.newTreatment.prescriptions[0].quantity;
    this.newTreatment.quantity_measure =
      this.newTreatment.prescriptions[0].quantity_measure;
    this.newTreatment.duration = this.newTreatment.prescriptions[0].duration;
    /*this.newTreatment.detection_time = this.newTreatment.detection_time;*/
    this.newTreatment.srcs = [];

    this.newTreatment.prescriptions[0].images.forEach((el) => {
      this.newTreatment.srcs.push(Object.assign({}, el));
    });

    const items = this.appMemory.measures;
    const quantity = this.newTreatment.quantity_measure;
    this.measuresSelectorModel = items.filter((el) => el.id === quantity);
    this.calcMaxLength(this.newTreatment.quantity);
  }

  changeTreatmentStatus(id: number, body: any) {
    this.getService.changeTreatmentStatus(id, body).then(
      (res: any) => {
        this.hideModal();
        this.getHorseByUserRole();
        this.notificationsService.success(
          `${this.translation['closeTreatment']}`,
          `${this.translation['successClosedAndMovedToArchive']}`
        );
      },
      (err: any) => {
        console.log('ERR', err);
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation['closeTreatment']}`,
          `${this.translation['errorOccurred']}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  changeSwitcher(val) {
    this.reportDate.switcher = val;
    this.datePicker4.minDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 10)
    );
    this.datePicker3.maxDate = new Date() as Date;
    this.datePicker4.currentDate = new Date() as Date;
    this.datePicker3.currentDate = new Date() as Date;
  }

  public sendReport() {
    this.serverError = null;

    if (new Date(this.reportDate.from) > new Date(this.reportDate.to)) {
      this.serverError = [this.translation['incorrectDatesRanges']];
      return;
    }

    const body = {
      start: this.reportDate.from,
      end: !this.reportDate.switcher
        ? this.reportDate.to
        : this.reportDate.from,
    };

    this.isRequestInProgress5 = true;
    this.getService.sendReport(body).then(
      (res: any) => {
        this.isRequestInProgress5 = false;
        this.hideModal();
        this.clearUserInput();
        this.notificationsService.success(
          `${this.translation['sendReport']}`,
          `${this.translation['report']} ${this.translation['sentSuccess']}`
        );
      },
      (err: any) => {
        if (err.status === 500) {
          this.serverError = [this.translation['errorOccurred']];
        } else {
          this.serverError = this.objectToArray(JSON.parse(err._body));
        }
        this.isRequestInProgress5 = false;
      }
    );
  }

  deleteTreatment(form: any) {
    this.isRequestInProgress = true;

    const role = this.appMemory.roles[this.appMemory.user.roles[0].id];

    this.getService
      .deleteTreatment(
        this.currentTreatment ? this.currentTreatment.id : this.newTreatment.id,
        role
      )
      .then(
        (res: any) => {
          this.clearUserInput(form);
          this.hideModal();
          this.getHorseByUserRole();
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['deleteTreat']}`,
            `${this.translation['treatment']} ${this.translation['deletedSuccess']}`
          );
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation['deleteTreat']}`,
            `${this.translation['errorOccurred']}`
          );
        }
      );
  }

  getTranslation() {
    this.translateService.get('TREATS.editTreat').subscribe((word: string) => {
      this.translation['editTreat'] = word;
    });
    this.translateService
      .get('TREATS.successClosedAndMovedToArchive')
      .subscribe((word: string) => {
        this.translation['successClosedAndMovedToArchive'] = word;
      });
    this.translateService
      .get('TREATS.closeTreatment')
      .subscribe((word: string) => {
        this.translation['closeTreatment'] = word;
      });
    this.translateService
      .get('TREATS.updateTreatmentStatus')
      .subscribe((word: string) => {
        this.translation['updateTreatmentStatus'] = word;
      });
    this.translateService.get('TREATS.sendReport').subscribe((word: string) => {
      this.translation['sendReport'] = word;
    });
    this.translateService.get('TREATS.report').subscribe((word: string) => {
      this.translation['report'] = word;
    });
    this.translateService.get('TREATS.treatment').subscribe((word: string) => {
      this.translation['treatment'] = word;
    });
    this.translateService
      .get('TREATS.deleteTreat')
      .subscribe((word: string) => {
        this.translation['deleteTreat'] = word;
      });
    this.translateService
      .get('TREATS.incorrectDatesRanges')
      .subscribe((word: string) => {
        this.translation['incorrectDatesRanges'] = word;
      });
    this.translateService
      .get('OTHER.updatedSuccess')
      .subscribe((word: string) => {
        this.translation['updatedSuccess'] = word;
      });
    this.translateService
      .get('OTHER.edittedSuccess')
      .subscribe((word: string) => {
        this.translation['edittedSuccess'] = word;
      });
    this.translateService.get('OTHER.sentSuccess').subscribe((word: string) => {
      this.translation['sentSuccess'] = word;
    });
    this.translateService
      .get('OTHER.deletedSuccess')
      .subscribe((word: string) => {
        this.translation['deletedSuccess'] = word;
      });
    this.translateService
      .get('OTHER.errorOccurred')
      .subscribe((word: string) => {
        this.translation['errorOccurred'] = word;
      });
    this.translateService.get('OTHER.uploadImage').subscribe((word: string) => {
      this.translation['uploadImage'] = word;
    });
    this.translateService
      .get('HORSES.description')
      .subscribe((word: string) => {
        this.translation['description'] = word;
      });
    this.translateService.get('OTHER.otherDrug').subscribe((word: string) => {
      this.translation['otherDrug'] = word;
    });
  }

  public isTreatmentEditable(treatment: Treatment): boolean {
    if (
      !treatment ||
      !treatment.horse ||
      !treatment.horse.is_active ||
      treatment.horse.is_eligible ||
      treatment.status === 'closed' ||
      !this.appMemory.user ||
      this.appMemory.user.roles.length === 0
    ) {
      return false;
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1: // instrucotr / trainer
        if (environment.disableTreatmentEditInstructorNotOwned) {
          if (treatment.request) {
            return this.appMemory.user.id === treatment.request.user_id;
          } else {
            return true;
          }
        } else {
          return true;
        }
      case 3: // vet
        if (treatment.request && treatment.request.status === 'approved') {
          return false;
        }
        if (treatment.request) {
          return this.appMemory.user.id === treatment.request.user_id;
        }
    }
    return false;
  }

  public setCurrentTreatment(treatment) {
    this.currentTreatment = treatment;
    this.hasNoTreatment = treatment.route === RouteTypes.noTreatment;
    this.debug(treatment);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/all-treatments/all-treatments.component.ts